import yup from '../../../config/yup';

export const edfiWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('edfiWriter'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    debug: yup.boolean(),
    version: yup.string(),
    interval: yup.number(),
    count: yup.number(),
    path: yup.string(),
  }),
});
